/**
 * <lj-collection> — filter and sort without a full page reload.
 * Submits the filter form as a URL, fetches the rendered section, and swaps
 * the results in. History is updated so Back and sharing both work.
 */
class LJCollection extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('#CollectionFilterForm');
    this.results = this.querySelector('[data-collection-results]');
    if (!this.form || !this.results) return;

    this.form.addEventListener('change', (e) => {
      if (e.target.matches('[data-filter-input]')) this.apply();
    });

    this.addEventListener('click', (e) => {
      // Tabs are anchors, not inputs, so the change listener above misses them
      const tab = e.target.closest('[data-tab-link]');
      if (tab) {
        e.preventDefault();
        this.navigate(tab.href);
        return;
      }

      // Keep pagination links in-page too
      const link = e.target.closest('.pagination a');
      if (!link) return;
      e.preventDefault();
      this.navigate(link.href);
    });

    window.addEventListener('popstate', () => {
      this.navigate(window.location.href, false);
    });
  }

  apply() {
    const params = new URLSearchParams(new FormData(this.form));

    // Drop empty values so the URL stays clean and shareable
    Array.from(params.keys()).forEach((key) => {
      if (params.getAll(key).every((v) => v === '')) params.delete(key);
    });

    // Changing filters must return to page 1 — the current page may not
    // exist in the narrowed result set.
    params.delete('page');

    const query = params.toString();
    const url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    this.navigate(url);
  }

  async navigate(url, push = true) {
    this.classList.add('is-loading');

    try {
      const res = await fetch(url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const freshResults = doc.querySelector('[data-collection-results]');
      if (freshResults) this.results.innerHTML = freshResults.innerHTML;

      // Filter counts and active states change with the results
      const freshForm = doc.querySelector('#CollectionFilterForm');
      if (freshForm && this.form) this.form.innerHTML = freshForm.innerHTML;

      if (push) window.history.pushState({}, '', url);

      // No scroll-into-view: the tab strip stays in the viewport while
      // filtering, so moving the page under the shopper would be jarring.
    } finally {
      this.classList.remove('is-loading');
    }
  }
}

customElements.define('lj-collection', LJCollection);
